'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(require('react'));

/**
 * Component dependencies
 */

/**
 * Component
 */


var Icon = function Icon(_ref) {
  var color = _ref.color,
      i18n = _ref.i18n;
  return /*#__PURE__*/react.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: color
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8.27686 4.34644L7.42834 5.19496L12.224 9.99059L7.42334 14.7912L8.27187 15.6397L13.921 9.99059L8.27686 4.34644Z",
    fill: color
  }));
};

Icon.defaultProps = {
  color: 'rgba(0, 0, 0, 0.9)'
};
/**
 * Export component
 */

var ChevronRight20 = Icon;

module.exports = ChevronRight20;
